import { datalayer } from "../datalayer";

export const useDatalayer = () => datalayer;
